module.exports = __webpack_public_path__ + "media/bootstrap-icons/box-arrow-left-35166c9f.svg";